export const formatCount = (count: number, maximumFractionDigits = -1): string => {
  if (count >= 1000000) {
    return `${(count / 1000000).toFixed(3)}M`.replace('.000', '');
  }

  if (maximumFractionDigits === -1) {
    if (count < 1) {
      maximumFractionDigits = 7;
    } else if (count <= 1000) {
      maximumFractionDigits = 4;
    } else {
      maximumFractionDigits = 0;
    }
  }

  return count.toLocaleString(undefined, { maximumFractionDigits });
};

export const formatUsd = (amount: number): string => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return formatter.format(amount);
};

export const formatPercent = (amount: number): string => `${(amount * 100).toFixed(2)}%`;

export const sumArray = (arr: number[]) => arr.reduce((total, current) => total + current, 0);
